import configObjectTypes from './configObjectTypes';
import LinkConigurationWrapper from 'components/ConfigWrappers/LinkConfigurationWrapper';
import ModalConfigurationWrapper from 'components/ConfigWrappers/ModalConfigurationWrapper';

export default {
  [configObjectTypes.link]: (NativeComponent) => LinkConigurationWrapper(NativeComponent),
  [configObjectTypes.modal]: (NativeComponent) => ModalConfigurationWrapper(NativeComponent),
};
